export default "__VITE_ASSET__CDjDlnIb__"